<template>
  <div class="booking-block__header">
    <div class="booking-block__header-wrap">
      <a class="booking-block__logo-wrap" href="/" rel="home">
        <img class="booking-block__logo-wrap-img" :src="`${imagesPath}booking-header-logo.png`" title="">
      </a>
      <div class="booking-block__nav">
        <!--<div @click="stepChange(1, counter)" :class="[{'is-current': counter === 1}, {'is-finished': this.counter > 1 }, 'booking-block__nav-step']">-->
        <!--            <span class="booking-block__nav-number">-->
        <!--                <span class="booking-block__nav-num">1</span>-->
        <!--                <span class="booking-block__nav-num-ico"></span>-->
        <!--            </span>-->
        <!--  <span class="booking-block__nav-title">Area</span>-->
        <!--</div>-->
        <div @click="stepChange(1, counter)" :class="[{'is-current': this.counter === 1}, {'is-finished': this.counter > 1}, 'booking-block__nav-step']">
                    <span class="booking-block__nav-number">
                        <span class="booking-block__nav-num">1</span>
                        <span class="booking-block__nav-num-ico"></span>
                    </span>
          <span class="booking-block__nav-title">Options</span>
        </div>
        <div @click="stepChange(2, counter)" :class="[{'is-current': this.counter === 2}, {'is-finished': this.counter > 2}, 'booking-block__nav-step']">
                    <span class="booking-block__nav-number">
                        <span class="booking-block__nav-num">2</span>
                        <span class="booking-block__nav-num-ico"></span>
                    </span>
          <span class="booking-block__nav-title">Apt. size</span>
        </div>
        <div @click="stepChange(3, counter)" :class="[{'is-current': this.counter === 3}, {'is-finished': this.counter > 3}, 'booking-block__nav-step']">
                    <span class="booking-block__nav-number">
                        <span class="booking-block__nav-num">3</span>
                        <span class="booking-block__nav-num-ico"></span>
                    </span>
          <span class="booking-block__nav-title">Frequency</span>
        </div>
        <div @click="stepChange(4, counter)" :class="[{'is-current': this.counter === 4}, {'is-finished': this.counter > 4}, 'booking-block__nav-step']">
                    <span class="booking-block__nav-number">
                        <span class="booking-block__nav-num">4</span>
                        <span class="booking-block__nav-num-ico"></span>
                    </span>
          <span class="booking-block__nav-title">Dates</span>
        </div>
        <div @click="stepChange(5, counter)" :class="[{'is-current': this.counter === 5}, {'is-finished': this.counter > 5}, 'booking-block__nav-step']">
                    <span class="booking-block__nav-number">
                        <span class="booking-block__nav-num">5</span>
                        <span class="booking-block__nav-num-ico"></span>
                    </span>
          <span class="booking-block__nav-title">Time</span>
        </div>
        <div @click="stepChange(6, counter)" :class="[{'is-current': this.counter === 6}, {'is-finished': this.counter > 6}, 'booking-block__nav-step']">
                    <span class="booking-block__nav-number">
                        <span class="booking-block__nav-num">6</span>
                        <span class="booking-block__nav-num-ico"></span>
                    </span>
          <span class="booking-block__nav-title">Address</span>
        </div>
        <div :class="[{'is-current': this.counter === 7}, {'is-finished': this.counter > 7}, 'booking-block__nav-step booking-block__nav-step--payment']">
                    <span class="booking-block__nav-number">
                        <span class="booking-block__nav-num">7</span>
                        <span class="booking-block__nav-num-ico"></span>
                    </span>
          <span class="booking-block__nav-title">Payment</span>
        </div>
        <div class="booking-block__header-price">
          <span class="booking-block__header-price-name">Price: </span>
          <span class="booking-block__header-price-sum">{{ total }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapState} from 'vuex';
import Global from '../../../js/shared/global';
import BlockBookingFooter from './BlockBookingFooter';

export default {
  beforeMount() {
    // const entries = performance.getEntriesByType('navigation');
    // const entryType = entries.map(nav => nav.type);
    // // if is in array (use === if is not in array)
    // if (entryType.indexOf('back_forward') !== -1) {
    //   this.$store.dispatch('setStepCount', 7);
    // }

    const isBack = Global.readCookie('isBack');
    console.log('header back', isBack);
    if (isBack) {
      if (isBack === true) {
        this.$store.dispatch('setStepCount', 7);
      }
    }
  },
  methods: {
    stepChange(step, counter) {
      if (step > counter) {
        return false;
      }
      const $ = jQuery.noConflict();
      const steps = $('.js-booking-step');
      const stepId = steps.eq(step - 1).attr('id');
      const previousStepId = steps.eq(step - 2).attr('id');
      let flag = false;
      const clickedStep = steps.eq(step - 1).attr('id');
      const currentStep = this.$store.getters['getCurrentStep'];
      // if (currentStep === 'BlockStepLocation') {
      //   if ($('#BlockStepLocation .js-custom-step-error:visible').length) {
      //     flag = true;
      //   }
      // }
      if (currentStep === 'BlockStepOptions') {
        if ($('#BlockStepOptions .js-cleaning-error:visible').length) {
          flag = true;
        }
      }
      if (currentStep === 'BlockStepFrequency') {
        if ($('#BlockStepFrequency .js-cleaning-error:visible').length) {
          flag = true;
        }
      }
      if (currentStep === 'BlockStepDates') {
        if ($('#BlockStepDates .js-date-error:visible').length) {
          flag = true;
        }
      }
      if (currentStep === 'BlockStepTime') {
        if ($('#BlockStepTime .js-date-error-time:visible').length) {
          flag = true;
        }
      }
      if (currentStep === 'BlockStepAddress') {
        if ($('#BlockStepAddress .js-date-error:visible').length) {
          flag = true;
        }
      }

      const jumpStep = Global.readCookie('jumpStep');
      const stepCheck = this.checkStepFlag(jumpStep, step - 1);
      if (!Global.readCookie('jumpStep')) {
        steps.hide();
        steps.eq(step - 1).css('display', '');
        Global.setCookie('jumpStep', step + 1);
        this.$store.dispatch('setPreviousStep', previousStepId);
        this.$store.dispatch('setCurrentStep', clickedStep);
        this.$store.dispatch('setNextStep', steps.eq(step).attr('id'));
      }
      if (flag && stepCheck) {
        return false;
      } else {
        steps.hide();
        steps.eq(step - 1).css('display', '');
        Global.setCookie('jumpStep', step + 1);
        this.$store.dispatch('setPreviousStep', previousStepId);
        this.$store.dispatch('setCurrentStep', clickedStep);
        this.$store.dispatch('setNextStep', steps.eq(step).attr('id'));
      }
    },
    checkStepFlag(jumpStep, step) {
      if (!jumpStep) {
        return false;
      }
      return parseInt(jumpStep) - 1 <= step;
    },
  },
  data() {
    return {
      isEntry: false,
      imagesPath: process.env.BASE_URL + 'wp-content/themes/fws-sproost/src/assets/images/',
      clickedNum: this.counter,
    };
  },
  computed: {
    ...mapState({
      counter: state => state.Base.stepCount,
      total: state => state.Base.total,
      validStep: state => state.Base.validStep,
    }),
  },
};
</script>


<style lang="scss" scoped>
.booking-block__header {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  background-color: $cornflower-blue;
  width: 100%;
  padding: 25px 15px;
  box-shadow: 0 4px 30px rgba(13, 50, 59, 0.07);
  will-change: transform;
  z-index: 1000;

  @include mq($xl) {
    padding: 20px 15px;
  }

  @include mq(350px) {
    padding: 20px 10px;
  }
}

.booking-block__header-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1680px;
  margin: 0 auto;

  @include mq(1800px) {
    max-width: fit-content;
  }

  @include mq(640px) {
    max-width: 100%;
  }
}

.booking-block__nav {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 13px 25px 22px;
  justify-content: center;
  background-color: $royal-blue;
  max-width: 100%;
  width: 100%;
  border-radius: 10px;

  @include mq($lap-large) {
    justify-content: space-between;
    padding: 13px 15px 22px;
  }

  @include mq($xl) {
    justify-content: flex-start;
  }

  @include mq($md) {
    padding: 0px 15px 10px;
  }

  @include mq(640px) {
    padding: 0px 5px 10px;
    justify-content: space-between;
    flex-wrap: nowrap;
  }
}

.booking-block__logo-wrap {
  max-width: 49px;
  margin-right: 15px;

  @include mq(640px) {
    max-width: 30px;
    margin-right: 5px;
  }

  @include mq($xs-phone) {
    max-width: 27px;
    min-width: 27px;
    margin-right: 5px;
  }
}

.booking-block__nav-step {
  display: flex;
  align-items: center;
  margin: 10px 27px 0 0;

  &.booking-block__nav-step--payment {
    &::after {
      display: none;
    }
  }

  &:last-of-type {
    margin-right: 0;

    &::after {
      display: none;
    }

    .booking-block__nav-title {
      margin-right: 0;
    }
  }

  &::after {
    content: '';
    display: block;
    border: 1px dashed $baby-blue;
    width: 20px;

    @include mq(1325px) {
      width: 10px;
    }

    @include mq(640px) {
      display: none;
    }
  }

  &.is-current {
    @include mq(640px) {
      margin: 10px 5px 0 0;
    }

    .booking-block__nav-number {
      background-color: $tree-poppy;
    }

    .booking-block__nav-title {
      color: $white;
    }

    &::after {
      border: 1px solid $white;
    }

    .booking-block__nav-title {
      @include mq(640px) {
        display: block;
      }
    }
  }

  &.is-finished {
    .booking-block__nav-number {
      background-color: $white;
    }

    @include hover {
      cursor: pointer;
      .booking-block__nav-number {
        background-color: $dodger-blue !important;
      }
    }

    .booking-block__nav-num {
      opacity: 0;
      visibility: hidden;
    }

    .booking-block__nav-num-ico {
      opacity: 1;
      visibility: visible;
    }
  }

  @include mq(1800px) {
    margin: 10px 15px 0 0;
  }

  @include mq(1650px) {
    margin: 10px 10px 0 0;
  }

  @include mq($xl) {
    max-width: 17%;
    width: 100%;
  }

  @include mq($lg) {
    max-width: 21%;
  }

  @include mq($md) {
    max-width: 30%;
  }

  @include mq(640px) {
    max-width: fit-content;
    margin: 10px 0 0 0;
  }
}

.booking-block__nav-number {
  position: relative;
  display: block;
  height: 35px;
  width: 35px;
  min-width: 35px;
  border-radius: 50%;
  background-color: $cornflower-blue;
  margin-right: 15px;
  transition: $dur $ease;

  @include mq(1650px) {
    margin-right: 10px;
  }

  @include mq(1300px) {
    height: 30px;
    width: 30px;
    min-width: 30px;
  }

  @include mq($xs-phone) {
    height: 20px;
    width: 20px;
    min-width: 20px;
    margin-right: 5px;
  }

  @include mq(370px) {
    height: 17px;
    width: 17px;
    min-width: 17px;
  }
}

.booking-block__nav-num {
  font-size: 12px;
  font-family: $font-main;
  font-weight: 600;
  line-height: 1.2;
  color: $white;
  @include center;

  @include mq(340px) {
    font-size: 11px;
  }
}

.booking-block__nav-num-ico {
  @include center;
  opacity: 0;
  visibility: hidden;
  transition: $dur $ease;

  &::before {
    content: '';
    background-image: url('data:image/svg+xml,%3Csvg aria-hidden="true" focusable="false" data-prefix="far" data-icon="check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-check fa-w-16 fa-3x"%3E%3Cpath fill="orange" d="M435.848 83.466L172.804 346.51l-96.652-96.652c-4.686-4.686-12.284-4.686-16.971 0l-28.284 28.284c-4.686 4.686-4.686 12.284 0 16.971l133.421 133.421c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-28.284-28.284c-4.686-4.686-12.284-4.686-16.97 0z" class=""%3E%3C/path%3E%3C/svg%3E');
    @include center;
    font-size: 14px;
    height: 14px;
    width: 14px;
  }

  @include mq($xs-phone) {

    &::before {
      font-size: 10px;
      height: 10px;
      width: 10px;
    }
  }
}

.booking-block__nav-title {
  font-size: 16px;
  font-family: $font-main;
  font-weight: 600;
  line-height: 1.2;
  color: $baby-blue;
  margin-right: 23px;
  transition: $dur $ease;

  @include mq(1650px) {
    font-size: 14px;
    margin-right: 15px;
  }

  @include mq($lap-large) {
    margin-right: 10px;
  }

  @include mq(1350px) {
    margin-right: 12px;
  }

  @include mq(1250px) {
    margin-right: 10px;
  }

  @include mq(640px) {
    display: none;
    margin-right: 10px;
  }

  @include mq($xs-phone) {
    font-size: 12px;
    margin-right: 0;
  }

  @include mq(370px) {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 35px;
    font-size: 11px;
  }
}

.booking-block__header-price {
  font-size: 16px;
  font-family: $font-main;
  font-weight: 600;
  line-height: 1.2;
  color: $baby-blue;
  transition: $dur $ease;
  position: relative;
  padding-left: 27px;
  margin-top: 10px;

  &::before {
    content: '';
    height: 100%;
    width: 1px;
    background-color: $white;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  @include mq(1800px) {
    padding-left: 15px;
  }

  @include mq(1650px) {
    font-size: 14px;
    padding-left: 10px;
  }

  @include mq(1325px) {
    display: flex;
    flex-direction: column;
    margin-left: 0;
  }

  @include mq(1310px) {
    display: inline-block;
    flex-direction: row;
    margin-left: auto;
  }

  @include mq($xl) {
    position: absolute;
    right: 15px;
    bottom: 5px;

    &::before {
      display: none;
    }
  }

  @include mq(640px) {
    bottom: -17px;
    right: 5px;
    font-size: 12px;
  }
}

.booking-block__header-price-sum {
  font-weight: bold;
  color: $white;

  &::before {
    content: '$';
  }
}
</style>
